var map = {
	"./6.png": "ygWY",
	"./6en.png": "U84e"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Yhq/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia ^\.\/6.*\.png$
// module id = Yhq/
// module chunks = 0